var _path, _path2, _g, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 796,
    height: 714,
    viewBox: "0 0 796 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3101_4449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3101_4449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 796,
    height: 714
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M796 0H0V714H796V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3101_4449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3101_4449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -216,
    y: -106,
    width: 3459,
    height: 3837
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-216 -106H3243V3731H-216V-106Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3101_4449)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.439 355.146L485.599 140.168L111.439 355.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.439 355.146L485.599 140.168",
    stroke: "#C1EBDF",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.439 496.146L574.599 281.168L200.439 496.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.439 496.146L574.599 281.168",
    stroke: "#C1EBDF",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670.439 227.146L699.6 210.17L670.439 227.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.439 227.146L699.6 210.17",
    stroke: "#C1EBDF",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.439 612.146L616.599 446.169L332.439 612.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.439 612.146L616.599 446.169",
    stroke: "#C1EBDF",
    strokeWidth: 92.0138,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M686.107 462.388C690.657 462.866 693.964 466.949 693.485 471.5C693.007 476.051 688.924 479.357 684.373 478.879C679.823 478.401 676.516 474.318 676.995 469.767C677.473 465.216 681.556 461.91 686.107 462.388Z",
    stroke: "#00C1A3",
    strokeWidth: 4.28355
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4 631.173C209.883 631.959 215.32 638.674 214.534 646.157C213.747 653.64 207.033 659.077 199.55 658.291C192.066 657.504 186.629 650.79 187.416 643.307C188.202 635.823 194.917 630.386 202.4 631.173Z",
    stroke: "#00C1A3",
    strokeWidth: 7.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.571 72.3504C401.054 73.1369 406.491 79.8513 405.705 87.3345C404.918 94.8177 398.204 100.255 390.72 99.4683C383.237 98.6818 377.8 91.9675 378.587 84.4843C379.373 77.0011 386.087 71.5639 393.571 72.3504Z",
    stroke: "#00C1A3",
    strokeWidth: 7.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7071 249.9C81.1446 249.9 83.9356 252.691 83.9356 256.129C83.9356 259.566 81.1446 262.357 77.7071 262.357C74.2695 262.357 71.4785 259.566 71.4785 256.129C71.4785 252.691 74.2695 249.9 77.7071 249.9Z",
    stroke: "#00C1A3",
    strokeWidth: 5.14888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.471 656.074C564.908 656.074 567.699 658.865 567.699 662.303C567.699 665.74 564.908 668.531 561.471 668.531C558.033 668.531 555.242 665.74 555.242 662.303C555.242 658.865 558.033 656.074 561.471 656.074Z",
    stroke: "#00C1A3",
    strokeWidth: 5.14888
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.228 70.3242L639.953 46.5478",
    stroke: "#00C1A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.594 54.7534L648.37 62.4788",
    stroke: "#00C1A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.643 478.453L109.534 454.421",
    stroke: "#00C1A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4697 463.158L118.501 470.049",
    stroke: "#00C1A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.272 586.619L627.896 562.259",
    stroke: "#00C1A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.311 571.772L637.67 577.396",
    stroke: "#00C1A3",
    strokeWidth: 3
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398.111 177.281C497.315 177.281 577.861 257.827 577.861 357.031C577.861 456.235 497.315 536.781 398.111 536.781C298.906 536.781 218.36 456.235 218.36 357.031C218.36 257.827 298.906 177.281 398.111 177.281Z",
    fill: "#00C1A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398 194.281C487.821 194.281 560.749 267.209 560.749 357.031C560.749 446.853 487.821 519.781 398 519.781C308.178 519.781 235.25 446.853 235.25 357.031C235.25 267.209 308.178 194.281 398 194.281Z",
    fill: "#00C1A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 363L368.5 406L471.5 303",
    stroke: "white",
    strokeWidth: 18
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3101_4449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 796,
    height: 714,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.cc1b6fa58b9c8ce511dffa6a567b5159.svg";
export { ForwardRef as ReactComponent };